import styled, { css } from 'styled-components'

import { basketWidth } from '@src/constants/basketWidth'
import { breakpoints } from '@src/constants/breakpoints'

export const Container = styled.div<{ $isStackedMenuView: boolean }>`
  background-color: white;
  width: 100vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${({ $isStackedMenuView }) =>
    $isStackedMenuView ? 'column' : 'row'};
  ${({ $isStackedMenuView }) =>
    $isStackedMenuView ? 'justify-content: space-between;' : 'height: 56px; '}

  border-bottom: 1px solid rgba(149, 157, 165, 0.2);
  box-shadow: rgba(149, 157, 165, 0.4) 0px -8px 24px;
`

export const MenuCapsuleWrapper = styled.div`
  padding: 0px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;

  /* Hide scrollbar */
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Add fade on the right edge */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    pointer-events: none;
    z-index: 1;
  }
`

export const FilterOverlay = styled.div`
  position: absolute;
  height: 52px;
  top: 11px;
  width: 52px;
  background-color: white;
  z-index: 1;
  right: 0px;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 0)
  );
`

export const OutletMenuSearchContainer = styled.div<{
  $isStackedMenuView: boolean
  displayPermanentCheckout: boolean
}>`
  display: flex;
  align-items: center;
  ${({ $isStackedMenuView }) => ($isStackedMenuView ? 'margin-top: 10px;' : '')}

  @media (min-width: ${breakpoints.largeTablet}px) {
    margin-right: 16px;
  }

  ${({ displayPermanentCheckout }) =>
    displayPermanentCheckout &&
    css`
      @media (min-width: ${breakpoints.wideDesktop}px) {
        margin-right: ${basketWidth.superWideDesktop}px;
      }

      @media (min-width: ${breakpoints.superWideDesktop}px) {
        margin-right: calc(${basketWidth.superWideDesktop}px + 10px);
      }
    `}
`
